import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-button-divider',
    templateUrl: './button-divider.component.html',
    styleUrls: ['./button-divider.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ButtonDividerComponent { }
